const sameUserItemId = (a, b) => {
  if (a == null || b == null) return false;
  return Number(a) === Number(b);
};

const isGridItemEquipped = (gridItem, currentEquipment) => {
  if (!gridItem || !currentEquipment) return false;
  switch (gridItem.slotType) {
    case 'weapon':
      return sameUserItemId(currentEquipment.weaponId, gridItem.id);
    case 'armor':
      return sameUserItemId(currentEquipment.armorId, gridItem.id);
    case 'helmet':
      return sameUserItemId(currentEquipment.helmetId, gridItem.id);
    case 'boot':
      return sameUserItemId(currentEquipment.bootId, gridItem.id);
    case 'shield':
      return sameUserItemId(currentEquipment.shieldId, gridItem.id);
    case 'earring':
      return sameUserItemId(currentEquipment.earringId, gridItem.id);
    case 'necklace':
      return sameUserItemId(currentEquipment.necklaceId, gridItem.id);
    case 'pot':
      return sameUserItemId(currentEquipment.potId, gridItem.id)
        || sameUserItemId(currentEquipment.potId2, gridItem.id)
        || sameUserItemId(currentEquipment.potId3, gridItem.id)
        || sameUserItemId(currentEquipment.potId4, gridItem.id);
    default:
      return false;
  }
};

export default isGridItemEquipped;
